import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from '../../../../data.service';
import { FormControl, FormGroup } from '@angular/forms';
import { GetCloudRequestTypeGQL, GetServiceRequestInputDataGQL } from '../../../../../generated/cloudapigql';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'sr-listing-filter-dialog',
    templateUrl: 'sr-listing-filter-dialog.html',
    styleUrls: ['sr-listing-filter-dialog.scss']
})
export class SRListingFilterDialog implements OnInit {
    @ViewChild(MatAutocompleteTrigger) unitAutoCompletetrigger: MatAutocompleteTrigger;

    myForm:FormGroup;
    filter = {
        requestStatus: [],
        orderBy: "",
        requestType: "",
        lastAssignTo: ""
    };
    selectedRequestTypeValue: any;
    selectedLastAssignToValue: any;
    requestTypeOptions:any;
    requestCriteria: any = {};
    propertyId: number;
    options: string[] = [];
    filteredOptions: Observable<string[]>;    

    constructor(
        public dialogRef: MatDialogRef<SRListingFilterDialog>,
        public dataService: DataService,
        private _getRequestType: GetCloudRequestTypeGQL,
        private getServiceRequestInputDataGQL: GetServiceRequestInputDataGQL,
        private _authService: AuthenticationService,
        @Inject(MAT_DIALOG_DATA) private data,

    ) {
        this.propertyId = this._authService.userInfo.property?.propertyId;
        if(data){
            this.selectedRequestTypeValue = data.filterState.requestType;            
        }
    }

    ngOnInit() {
        this.getSelectOptions();
        let orderby="desc";
        if(this.data.orderBy){
            orderby = this.data.orderBy
        }
        this.myForm = new FormGroup({
            orderBy: new FormControl(orderby),
            requestType: new FormControl(''),            
            lastAssignTo: new FormControl('')
        });
    }

    getSelectOptions() {        
        this._getRequestType.fetch().subscribe(result => {
            this.requestTypeOptions = result.data.getCloudRequestType
        })

        let result = this.getServiceRequestInputDataGQL.fetch({
            propertyId: this.propertyId
        }).pipe().subscribe(x => {
            this.requestCriteria = x.data.GetServiceRequestInputData;
            this.options = this.requestCriteria.assignTo.map(x => x.name);                        
            this.myForm.controls['lastAssignTo'].setValue(this.requestCriteria.assignTo.find(x => x.ID == this.data?.filterState?.lastAssignTo)?.name || '');
            this.filteredOptions = this.myForm.controls['lastAssignTo'].valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );                       
        });
    }
    
    // reset() {
    //     this.myForm.get("requestStatus").setValue(["Open","In Progress"]);
    //     this.myForm.get("orderBy").setValue("desc");
    // }

    onSubmit() {
        this.filter = this.myForm.value;
        // if ((this.filter.requestStatus.length == 0) && (this.dataService.filterHistory.requestStatus.length > 0)) {
        //     this.filter.requestStatus = this.dataService.filterHistory.requestStatus;
        // }
        // if (this.filter.requestStatus.length == 0) {
        //     this.filter.requestStatus = ["Open","In Progress","Resolved","Closed"]
        // }
        
        // this.dataService.filter.requestStatus = this.filter.requestStatus;
        this.dataService.filter.orderBy = this.filter.orderBy;
        if (this.filter.requestType != null && this.filter.requestType != '') {
            this.dataService.filter.requestType = this.filter.requestType;
        } else {
            this.dataService.filter.requestType = "";
        }
        if (this.filter.lastAssignTo != null && this.filter.lastAssignTo != '') {
            this.dataService.filter.lastAssignTo = this.requestCriteria.assignTo.find(x => x.name == this.filter.lastAssignTo).ID;
        } else {
            this.dataService.filter.lastAssignTo = "";
        }
        this.dialogRef.close( this.dataService.filter);
    }

    clearFilter() {
        this.dataService.filter.requestType = "";
        this.dataService.filter.lastAssignTo = "";        
        this.myForm.get('requestType').setValue("");
        this.myForm.get('lastAssignTo').setValue("");        
        // this.dialogRef.close(this.dataService.filter);
    }

    clearFormControl(formControlName: string) {
        this.myForm.get(formControlName).markAsPristine()
        this.myForm.get(formControlName).markAsUntouched();
        this.myForm.get(formControlName).setValue('')        
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }
}
